import { CacheProvider } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from '@ahora-patagonia/i18n/react';
import { App } from './App.js';
import { createEmotionCache } from './emotion-cache.js';
import { i18n } from './i18n/index.js';
import { AppCoordinatorProvider } from './modules/shared/coordinators/AppCoordinatorProvider.js';
import { SsrDataProvider } from './modules/shared/ssr/SsrDataProvider.js';
import { readSsrData } from './modules/shared/ssr/serialize.js';
import { theme } from './theme.js';

/**
 * Entry del browser: **hidrata** el HTML que ya vino renderizado del server (no monta de
 * cero). El estado del loader se lee de `window.__SSR_DATA__` y se inyecta con el mismo
 * provider que usó el server, así el primer render del cliente coincide con el del server.
 */
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <CacheProvider value={createEmotionCache()}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <AppCoordinatorProvider>
              <SsrDataProvider value={readSsrData()}>
                <App />
              </SsrDataProvider>
            </AppCoordinatorProvider>
          </I18nextProvider>
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  </StrictMode>,
);
